import styled from "styled-components";

export const SForm = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background: var(--neutral-100);
    border: 1px solid var(--neutral-300);
    border-radius: 2.5rem;
    box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);

    max-width: 600px;
    margin: 2rem .5rem;
    padding: 1rem 0; 

`

export const ButtonForm = styled.div `
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
`